module.exports = __webpack_public_path__ + "img/footer_home--active.b8ef5047.svg";